import { TeamPage } from '@/features/team/pages/TeamPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/$wsSlug/users')({
  component: TeamPage,
});
